import { useEffect, useRef } from 'react'

import { useAuth } from '@/context/authContext'
import { useFilters } from '@/context/filterContext'
import { useProject } from '@/context/projectContext'

const Logout = () => {
  const loggedOutOnce = useRef(false)

  const { logout } = useAuth()
  const { clearAllFilters } = useFilters()
  const { selectAllProjects } = useProject()

  useEffect(() => {
    if (loggedOutOnce.current) return

    loggedOutOnce.current = true
    clearAllFilters()
    selectAllProjects() // wipe current selected project
    logout()
  }, [clearAllFilters, logout, selectAllProjects])

  return <div></div>
}

export default Logout
